module.exports = __webpack_public_path__ + "img/way.62c0253b.png";